import React, { Component } from 'react'
import injectStyles from 'react-jss'
import ProgressBar from './ProgressBar'

const styles = {
  page: {
    textAlign: 'center',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#fa8327',
  },
  boxOuter: {
    width: '100%',
  },

}

class LoadingPage extends Component {

  state = {

  }

  componentDidMount = () => {
    this.interval = setInterval(this.update, 4)
    this.startEpoch = (new Date).valueOf()
  }

  componentWillUnmount = () => clearInterval(this.interval)

  update = () => {
    var msElapsed = (new Date).valueOf() - this.startEpoch
    this.setState({
      progress: getProgress(msElapsed),
    })
  }

  render = () => {
    const { classes, queryString } = this.props
    const { progress } = this.state
    return <div className={classes.page}>
      <div className={classes.boxOuter}>
        <Box>
          <div>{formatToZeroDecimals(progress)}</div>
          <br /><br /><br /><br />
          <ProgressBar progress={progress} />
        </Box>
      </div>
    </div>
  }
}

export default injectStyles(styles)(LoadingPage)

const Box = injectStyles({
  box: {
    width: 747,
    padding: '86px 168px',
    boxSizing: 'border-box',
    margin: '0 auto',
  },
})(({ classes, children }) => <div className={classes.box}>
  {children}
</div>)


/**
 * Gets a progress value from 0 to 100. The more time elapsed the
 * closer to 100 it will be. However it will never actually reacth
 * 100
 * @param {number} msElapsed
 * @returns {number}
 */
function getProgress(msElapsed){
  return 100 - (1000 / (1000 + msElapsed) * 100)
}

/**
 * Removes decimals
 * @param {num}
 * @returns {num}
 */
function formatToZeroDecimals(num){
  if (typeof num !== 'number') return 0
  return Math.floor(num)
}


// WEBPACK FOOTER //
// ./src/pages/Loading/Loading.js